module.exports = __webpack_public_path__ + "static/media/console-fuel-filler.e34e4e47.jpg";